<template>
  <div class="col-sm-12 table-responsive">
    <h3>{{ variant.name }}</h3>
    <table id="menu-planner-table" class="table table-bordered">
      <thead>
      <tr class="menu-header">
        <th style="width: 150px; min-width: 150px;">{{ trans('menu_planner.meal') }}</th>
        <th style="width: 150px; min-width: 150px;">{{ trans('badge.badge') }}</th>
        <th style="width: 700px; min-width: 700px;">{{ trans('menu_planner.final_meal') }}</th>
        <th style="width: 150px; min-width: 150px;">{{ trans('menu_planner.final_meal_id') }}</th>
        <th style="width: 150px; min-width: 150px;">{{ trans('meal.entity.rate') }}</th>
        <th style="width: 150px; min-width: 150px;">{{ trans('meal.entity.tags') }}</th>
        <th v-for="(basket, index) in baskets" :key="index" style="width: 618px; min-width: 618px;">
          {{ basket.name }}
        </th>
      </tr>
      </thead>
      <tbody v-if="baskets.length">
      <template v-for="(type, typeIndex) in mealTypes">
        <menu-planner-edit-variant-meal
            :key="typeIndex"
            :meal-type="type"
            :variant="variant"
            :initial-baskets="baskets"
            :date="date"
            :brand="brand"
            @update-baskets-details="getBasketsDetails"
        />
      </template>
      </tbody>
      <tfoot>
      <tr>
        <th>{{ trans('menu_planner.details') }}</th>
        <td></td>
        <td class="active"></td>
        <td></td>
        <td></td>
        <td></td>
        <td
            v-for="(basket, index) in baskets" :key="index"
            :class="{'active': index % 2 === 0, '': index % 2 !== 0 }"
        >
          <span v-if="loading">
            <span class="glyphicon glyphicon-refresh glyphicon-refresh-animate"></span>
          </span>
          <span v-else-if="basketsDetails[index]">
            {{ trans('menu_planner.caloryfic_info.before.caloryfic') }}
            {{ dcNumberFormat(basketsDetails[index].calorificInfo.caloryfic) }}
            {{ trans('menu_planner.caloryfic_info.after.caloryfic') }}
            {{ dcNumberFormat(basketsDetails[index].calorificInfo.caloryfic * KCAL_TO_KJ_RATIO) }}
            {{ trans('menu_planner.caloryfic_info.after.caloryfic_kj') }}<br/>
            {{ trans('menu_planner.caloryfic_info.before.carbohydrate_g') }}
            {{ dcNumberFormat(basketsDetails[index].calorificInfo.carbohydrateG) }}<br/>
            {{ trans('menu_planner.caloryfic_info.before.dietary_fiber_g') }}
            {{ dcNumberFormat(basketsDetails[index].calorificInfo.dietaryFiberG) }}<br/>
            {{ trans('menu_planner.caloryfic_info.before.fat_g') }}
            {{ dcNumberFormat(basketsDetails[index].calorificInfo.fatG) }}<br/>
            {{ trans('menu_planner.caloryfic_info.before.saturated_fatty_acids_g') }}
            {{ dcNumberFormat(basketsDetails[index].calorificInfo.saturatedFattyAcidsG) }}<br/>
            {{ trans('menu_planner.caloryfic_info.before.sugars_g') }}
            {{ dcNumberFormat(basketsDetails[index].calorificInfo.sugarsG) }}<br/>
            {{ trans('menu_planner.caloryfic_info.before.protein_g') }}
            {{ dcNumberFormat(basketsDetails[index].calorificInfo.proteinG) }}<br/>
            {{ trans('menu_planner.caloryfic_info.before.rate') }}0 / 0<br/>
            {{ trans('menu_planner.caloryfic_info.before.price_info') }}
            {{ dcNumberFormat(basketsDetails[index].priceInfo) }}<br/>
          </span>
        </td>
      </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import mixins from '@js/mixins'
import MenuPlannerEditVariantMeal from './MenuPlannerEditVariantMeal.vue'
import { KCAL_TO_KJ_RATIO } from '@const/menu_planner'

export default {
  components: {
    MenuPlannerEditVariantMeal,
  },
  mixins: [mixins],
  props: {
    date: {
      type: [String, Date],
      default: ''
    },
    brand: {
      type: [String, Number],
      default: ''
    },
    variant: {
      type: Object,
      default: () => {
      }
    },
    mealTypes: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      baskets: [],
      basketsDetails: [],
      basketsDetailsTimeout: null,
      loading: false,
    }
  },
  created() {
    this.KCAL_TO_KJ_RATIO = KCAL_TO_KJ_RATIO
  },
  mounted() {
    this.getBaskets()
    this.getBasketsDetails()
  },
  methods: {
    getBaskets() {
      this.$emit('loading-start')

      const url = Routing.generate('api_get_menu_planner_menu_planner', {
        context: 'menu_planner_dropdown',
        date: this.date,
        variant: this.variant.id
      })

      this.$http.get(url).then(response => {
        this.baskets = response.data
        this.$emit('loading-stop')
      }, response => {
        this.handleAjaxError(response)
        this.$emit('loading-stop')
      })
    },
    getBasketsDetails() {
      if (this.basketsDetailsTimeout) {
        clearTimeout(this.basketsDetailsTimeout)
      }

      this.loading = true
      const url = Routing.generate('api_get_menu_planner_menu_planner_details', {
        date: this.date,
        variant: this.variant.id
      })

      this.basketsDetailsTimeout = setTimeout(() => {
        this.$http.get(url).then(response => {
          this.basketsDetails = response.data
          this.loading = false
        }, response => {
          this.handleAjaxError(response)
          this.loading = false
        })
      }, 2000)
    }
  },
}
</script>

<style scoped>
.menu-header {
  background: #3B3F51;
  color: #fff;
}

#menu-planner-table td {
  vertical-align: middle;
}
</style>
